export const DEFAULT_GROUP_NAME = "common";